import startsWith from 'lodash-es/startsWith';
import {
    FETCH_START,
    FETCH_END,
    FETCH_ERROR,
    FETCH_CANCEL,
} from 'store/actions/fetchActions';
import { HEADER_MENU_PREFIX } from 'util/constants';


export default (previousState = 0, { type, meta }) => {

    switch (type) {
        case FETCH_START:
            if ( meta.menu && !startsWith(meta.menu, HEADER_MENU_PREFIX) ) {
                return previousState + 1;
            } else {
                return previousState;
            }
        case FETCH_END:
        case FETCH_ERROR:
        case FETCH_CANCEL:
            if ( meta.menu && !startsWith(meta.menu, HEADER_MENU_PREFIX) ) {
                return Math.max(previousState - 1, 0);
            } else {
                return previousState;
            }
            
        default:
            return previousState;
    }

};